import { PORTFOLIO_RIBBON_CHANGE_EVENT } from './constants'

export function portfolioRibbonOnChange() {
    return {
        type: PORTFOLIO_RIBBON_CHANGE_EVENT,
    }
}
